<template>
    <div class="container">
        <v-row>
            <v-col cols="11">
                <v-card-title class="titulopagina">PRODUCCION PLANTA HIDROLIZADO</v-card-title>
            </v-col>
            <v-col cols="1">
                <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                    <v-icon color="blue" large>help</v-icon>
                </v-alert>
            </v-col>
        </v-row>
        <modal-ayuda></modal-ayuda>
        <v-card>
            <v-card-text class="pb-0">
                <v-row>
                    <v-col cols="3" sm="3">
                        <p>Seleccione Fecha de Producción</p>
                        <date-picker class="dtpicker" v-model="fecha" @change="cargarProduccionTurno" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-text-field v-model="suma_mp_procesada" label="MMPP Procesada" disabled placeholder="Procesado"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-text-field v-model="produccion_dia" label="Producción diaria" disabled placeholder="Producción diaria"></v-text-field>
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>

        <!--tabla nueva produccion-->
        <v-card class="mt-2">
                <v-col class="ml-1 mr-1" v-if="alert">
                    <v-alert dense text type="success">
                    Producción Guardada Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-col>
            <v-simple-table dense fixed-header :style="{height: 'min-content', maxHeight: '300px', overflowY: 'auto'}">
                <thead>
                    <tr>
                        <th class="cabecera">Producto</th>
                        <th class="cabecera">Linea</th>
                        <th class="cabecera">Estanque</th>
                        <th class="cabecera">Producción</th>
                        <th class="cabecera">Rend</th>
                        <th class="cabecera">Observación</th>
                        <th class="cabecera">Folio Producción</th>
                        <th class="cabecera">Agregar Fila</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in lista_resumen" :key="item.id">
                        <td class="text-center">{{item.tipo_produccion}} </td>
                        <td class="text-center">
                            <v-select
                                v-model="item.lineas_id"
                                :items="lineas"
                                item-text="nombre_linea"
                                item-value="id"
                                color="blue darken-3"
                                persistent-hint
                                dense
                                @change="saveProduccion(item, index)"
                            ></v-select>
                        </td>
                        <td class="text-center">
                            <v-select
                                v-model="item.estanque_aceites_id"
                                :items="item.tipo_produccion_id == 3 ? estanques_filtrados(item).hidrolizado : estanques_filtrados(item).concentrado"
                                item-text="nombre"
                                item-value="id"
                                color="blue darken-3"
                                persistent-hint
                                dense
                                @change="saveProduccion(item, index)"
                            >
                            </v-select>
                        </td>
                        <td class="text-center">
                            <v-text-field v-model="item.produccion" @change="saveProduccion(item, index)" type="number" reverse dense></v-text-field>
                        </td>
                        <td class="text-right">
                            <template v-if="(suma_mp_procesada > 0 ) && (item.produccion > 0) "> {{ (item.produccion / suma_mp_procesada * 100).toFixed(1) }} %</template>
                        </td>
                        <td class="text-left">
                            <v-text-field v-model="item.observacion_aceite" type="text" @change="saveProduccion(item, index)" dense></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-text-field v-model="item.folio_produccion" type="text" @change="saveProduccion(item, index)" dense></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-btn @click="agregarFila(item,index)" small icon dark color="green darken 1"><v-icon>add_circle</v-icon></v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>
        <!--tabla nueva produccion-->
        <v-row>
            <v-col cols="5">
                <h3 class="pa-4">Recepciones Planta de Hidrolizado {{this.rango_fechas[0] | formatearFecha}} - {{this.rango_fechas[1] | formatearFecha}}</h3>
            </v-col>
            <v-col cols="3">
                <date-picker class="mt-4" v-model="rango_fechas" @change="cargarProduccionEstanques(true)" placeholder="Rango de Fechas a Mostrar" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="10">
                <v-card>
                    <v-simple-table height="700px" dense fixed-header>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th colspan="5"></th>
                                    <th class="cabecera" >Totales</th>
                                    <th class="cabecera" v-for="li in tipo_mps" :key="li.id">
                                        {{li.total | formatear_miles}}
                                    </th>
                                </tr>
                                <tr>
                                    <th class="cabecera">Fecha</th>
                                    <th class="cabecera">Ticket</th>
                                    <th class="cabecera">MateriaPrima</th>
                                    <th class="cabecera">Guía</th>
                                    <th class="cabecera">Kilos</th>
                                    <th class="cabecera">Procesado</th>
                                    <th class="cabecera" v-for="li in tipo_mps" :key="li.id">
                                        {{li.tipo_materia_prima}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in recepciones" :key="index">
                                    <td>{{ item.fecha }}</td>
                                    <td>{{ item.ticket }}</td>
                                    <td>{{ item.materia_prima }}</td>
                                    <td><span class="float-right" >{{ item.guia }}</span></td>
                                    <td><span class="float-right" >{{ item.peso | formatear_miles }} </span></td>
                                    <td>
                                        <span class="float-right" >
                                            <v-text-field  v-model="item.parcial" type="number" :disabled="!item.seleccionada" @change="saveSeleccionado(item, index)" reverse dense></v-text-field>
                                        </span>
                                    </td>
                                    <td v-for="mp in tipo_mps" :key="mp.id">
                                        <template v-if="item.mps_id == mp.mp_tipos_romana2">
                                            <input type="checkbox" @change="saveSeleccionado(item, index)" v-model="item.seleccionada" :checked="item.seleccionada > 0" />
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>

            <v-col cols="2">
                <v-card>
                    <v-simple-table
                        fixed-header
                        width="100%"
                        height="80vh"
                    >
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="cabecera text-center" colspan="5">STOCKS</th>
                            </tr>
                            <tr>
                                <th class="cabecera">Estanque</th>
                                <th class="cabecera">Litros</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,idx) in stocks_tks" :key="idx" :class="item.color">
                                <td class="text-center borde-left">{{item.estanque}}</td>
                                <td class="text-right borde-left">{{item.kilos | formatear_miles}}</td>
                            </tr>
                        </tbody>
                    </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="2">
                            {{ primero }} - {{ ultimo }}
                        </v-col>
                        <v-col cols="3">
                            <v-btn color="success" title="Seleccionar automáticamente las filas intermedias entre las seleccionadas" @click="seleccionarFilas">SELECCIONAR FILAS</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Loader_Lineal_Configurable from '@/components/shared/Loader_Lineal_Configurable.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
import Loader_Lineal from '@/components/shared/Loader_Lineal.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        primero:null,
        ultimo:null,
        cont:0,
        despacho: {},
        rango_fechas:'',
        produccion_dia: 0,
        mmpp_dia: 0, 
        stocks_tks: [],
        lista_prod: [],
        lista_resumen: [],
        estanques:[],
        recepciones:[],
        estanques_despacho:[],
        lineas:[],
        tipo_mps: [],
        tipo_produccion_id:2,
        fecha: new Date().toISOString().substr(0, 10),
        alert:false,
        despacho_romana: [],
        progreso_despacho:false,
        //configuracion para datatable
        cabeceras_estanques:[
            {
                text: 'Estanque',
                align: 'center',
                sortable: true,
                value: 'codigo',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Despacho',
                align: 'center',
                sortable: true,
                value: 'litros',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Acidez',
                align: 'center',
                sortable: true,
                value: 'acidez_aceite',
                class: 'light-blue darken-3 titulo2',
            },
        ],
        acciones:[]
    }),
    mounted() {
        this.cargarLineas();
        this.cargarProduccionTurno();
        this.cargarRecepciones();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Producción Planta Hidrolizado`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se realiza el ingreso de la producción de la planta de hidrolizado de forma diaria.`},
                {   tipo:`label`,   texto:`- Se selecciona una fecha para el ingreso de la producción, esto cargará la producción ingresada de ese día (si es que la hay) y las recepciones de materia prima.`},
                {   tipo:`imgtexto`, url:`help-planta-ensilaje-01.png`, ratio:'4.1', cols:'2', texto:`- En la primera tabla, se debe indicar la cantidad producida de cada producto en ese día y desde qué estanque se sacó, además de opcionalmente indicar una observación y un folio de producción asociado. Además, para cada producto, se puede agregar una nueva fila de producción para indicar cantidad producida desde un estanque distinto.`},
                {   tipo:`imgtexto`, url:`help-planta-ensilaje-02.png`, ratio:'3', cols:'2', texto:`- En la segunda tabla se muestran las recepciones de la planta de hidrolizado, en donde se puede indicar y seleccionar las guías que corresponden a la materia prima utilizada para la producción de ese día. A la derecha de la tabla de recepciones, a modo informativo, se muestra el stock disponible de cada estanque.`},
            ];
            
            Event.$emit('mostrar_alert', jiji);
        },
        async saveProdDiaria(){
            let url = `${this.base_url}produccion_aceite/prod_diaria`;
            let data = {
                fecha: this.fecha,
                produccion_dia: this.produccion_dia
            }
            await this.axios.post(url, data, this.headers).then((response)=>{
                console.log(response.data)
            }).catch((error)=>{
                console.log(error);
            });
        },
        async cargarLineas(){
            let url = `${this.base_url}lineas_all`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.lineas = response.data.data.filter(l => (l.planta == 'ensilaje') );
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },

        agregarFila(item,index){
            let nuevo = {
                id: null,
                tipo_produccion_id:item.tipo_produccion_id,
                tipo_produccion:item.tipo_produccion,
                fecha: item.fecha,
                lineas_id: item.lineas_id,
                turnos_id: item.turnos_id,
                tipo_mps_id: item.tipo_mps_id,
                estanque_aceites_id: null,
                mp_procesada: null,
                produccion: null,
                folio_produccion: null,
                observacion_aceite: null,
                revisado: 0,
            }
            Array.prototype.insert = function ( index, item ) {
                this.splice( index+1, 0, item );
            };
            this.lista_resumen.insert(index, nuevo);
        },

        async cargarProduccionTurno(){
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}produccion_ensilaje/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista_resumen = response.data.data;
                this.tipo_produccion = response.data.tipo_produccion;
                this.estanques = response.data.estanques;

                Event.$emit('inicializar_tabla', this.cabeceras, this.lista, this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
            this.produccion_dia_suma();
            this.cargarRecepciones();
        },

        async cargarRecepciones(){
            this.mostrarLoading({titulo:'Cargando Recepción Materia Prima...',color:'green'})

            let url = `${this.base_url}mp_procesada/mp_ensilaje/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('recepciones:',res.data);
                this.tipo_mps = res.data.mps;
                this.recepciones = res.data.data;
                this.ocultarLoading();
                this.suma_mps();
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar recepciones ");
                this.suma_mps();
            });
        },

        async cargarProduccionEstanques(token){
            let data = { hola: ''}
            if (token == true) {
                data = {    fecha_ini:this.rango_fechas[0],
                            fecha_fin:this.rango_fechas[1]}
            }
            let url = `${this.base_url}produccion_aceite/produccion_estanques`;
            await this.axios.post(url, data, this.headers).then((response)=>{
                this.lista_prod = response.data.data;
                this.stocks_tks = response.data.stocks;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },

        async seleccionarFilas(){
            if ((this.primero || this.primero === 0) && (this.ultimo || this.ultimo === 0)) {
                this.cont = 1;
                this.mostrarLoading({titulo:'Registrando Seleccionados ...'+this.cont, color:'green'})
                if (parseInt(this.primero) > parseInt(this.ultimo)) {
                    let temp_last = parseInt(this.primero)
                    this.primero = parseInt(this.ultimo)
                    this.ultimo = temp_last
                }
                this.recepciones.forEach((r, idx) => {
                    if ((idx > this.primero) && (idx < this.ultimo) && (r.seleccionada == 0)) {
                        this.$set(this.recepciones[idx],'seleccionada',1)
                        this.$set(this.recepciones[idx],'parcial',r.distribuir)
                        this.saveSeleccionado(r, null)
                        this.cont += 1
                        console.log(" seleccionada " + this.cont)
                    }
                });
                this.ocultarLoading();
            } else {
                console.log("no se encontró primera o ultima fila seleccionada. primera:" + this.primero + " ultima:" + this.ultimo )
            }
        },

        // TODO: hacer el grabar al hacer click en un checkbox
        async saveSeleccionado(item,idx){
            if ((item.seleccionada == true) || (item.seleccionada == 1)){
                item.seleccionada = 1
                if(item.distribuir < item.parcial){
                    this.$set(this.recepciones[idx],'parcial',item.distribuir)
                }
            } else {
                item.seleccionada = 0;
                if(idx != null){
                    this.$set(this.recepciones[idx],'parcial',0)
                }
            }
            console.log("item", item, "recepciones", this.recepciones[idx])
            if((item.seleccionada === 1) || (item.seleccionada === 0) && (item.total >= 0)){
                let url = `${this.base_url}mp_procesada/registrar_guia`;
                let data = {    fecha: this.fecha,
                                data: item,
                                recalcular:true,
                            }
                await this.axios.post(url, data, this.headers).then((response)=>{
                    if (idx != null){
                        if (this.primero == null) {
                            this.primero = idx
                        }else {
                            if (this.ultimo == null) {
                                this.ultimo = idx
                            } else {
                                this.primero = parseInt(this.ultimo)
                                this.ultimo = idx
                            }
                        }
                    }
                    this.alert = true;
                }).catch((error)=>{
                    console.log(error);
                    this.errorMessage(error, "Error al agregar recepción ");
                });
            }
            this.suma_mps();
        },

        async saveProduccion(item, index){
            this.produccion_dia_suma();
            let data = {
                fecha: this.fecha,
                turnos_id: 0,
                tipo_produccion_id: item.tipo_produccion_id,
                tipo_produccion: item.tipo_produccion,
                lineas_id: item.lineas_id,
                tipo_mps_id: item.tipo_mps_id,
                estanque_aceites_id: item.estanque_aceites_id,
                mp_procesada: this.suma_mp_procesada,
                produccion: item.produccion,
                folio_produccion: item.folio_produccion,
                observacion_aceite: item.observacion_aceite,
                revisado: 0,
            };

            this.alert = false;
            if((data.lineas_id > 0) && (data.fecha != null) && (data.produccion > 0) ){
                console.log('actualizando',item);

                if(item.id > 0){
                    // update
                    let url = `${this.base_url}producciones_diarias/${item.id}`;
                    await this.axios.put(url, data, this.headers).then((response) => {
                        this.alert = true;
                    }).catch((error)=>{
                        console.log(error);
                        this.errorMessage(error, "Error al modificar produccion ");
                    });
                }else if (item.id == null){
                    // store new
                    let url = `${this.base_url}producciones_diarias`;
                    await this.axios.post(url, data, this.headers).then((response) => {
                        console.log("id", response.data.data.id);
                        this.$set(this.lista_resumen[index],'id',response.data.data.id);
                        this.alert = true;
                    }).catch((error)=>{
                        console.log(error);
                        this.errorMessage(error, "Error al grabar produccion ");
                    });
                }
            }
        },

        produccion_dia_suma(){
            let prod = 0;
            this.lista_resumen.forEach(e => {
                if (e.produccion && !isNaN(parseInt(e.produccion))){
                    prod += parseInt(e.produccion);
                }
            });
            console.log(prod);
            this.produccion_dia = prod;
        },

        suma_mps(){
            this.tipo_mps.forEach((objeto, idx) => {
                const id  = objeto.id;
                let suma = 0;
                this.recepciones.forEach(ob2 => {
                    if ((ob2.mps_id === id) && (ob2.seleccionada == 1)) {
                        suma += ob2.total;
                    }
                });

                this.$set(this.tipo_mps[idx],'total',suma);
            });
            
           // return litros;
        },

        estanques_filtrados(item) {
            const ids = {
                hidrolizado: [],
                concentrado: [],
            };
            this.lista_resumen.forEach(resumen => {
                const listado = resumen.tipo_produccion_id === 3 ? 'hidrolizado' : 'concentrado';
                ids[listado].push(resumen.estanque_aceites_id);
            });
            return {
                hidrolizado: this.estanques.filter(estanque => !ids.hidrolizado.includes(estanque.id) || item.estanque_aceites_id === estanque.id),
                concentrado: this.estanques.filter(estanque => !ids.concentrado.includes(estanque.id) || item.estanque_aceites_id === estanque.id),
            }
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'roles']),
        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        },
        suma_mp_procesada(){
            let suma = 0;
            this.tipo_mps.forEach(ob2 => {
                    suma += ob2.total;
            });
            return suma;
        },
        
    },
    components:{
        'modal':Modal,
        'modal-ayuda': ModalAyudas,
        'data-table':Data_Table,
        'loader-configurable':Loader_Lineal_Configurable,
        DatePicker
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
    .alert{
        color: red;
    }
    .titulo2{color: white !important; font-size: 1em !important; }
    th {color: white !important; font-size: 0.9em !important; }
    .borde-left{border-left: 1px solid white !important;}
    .filapar{
        background-color: #80DEEA;
    }
    .filaimpar{
        background-color:#80CBC4;
    }
    .mx-datepicker{width: 100%!important;}
</style>